// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import * as i from '../interfaces/index';

export class GeoPoint implements i.GeoPointInterface {
  latitude: number;
  longitude: number;

  constructor(kwargs?: i.GeoPointInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  static fromProto(proto: any): GeoPoint {
    let m = new GeoPoint();
    m = Object.assign(m, proto);
    return m;
  }

  toApiJson(): object {
    if (typeof this.latitude === 'undefined' && typeof this.longitude === 'undefined') {
      return {};
    }

    const toReturn = {};

    if (typeof this.latitude !== 'undefined') {
      toReturn['latitude'] = this.latitude;
    }
    if (typeof this.longitude !== 'undefined') {
      toReturn['longitude'] = this.longitude;
    }
    return toReturn;
  }
}
